import { MotorWrapper } from "application/motor";
import React from "react";


const KycFailMotor = React.lazy(() => import("./application/motor/pages/KycFail/index"));
const MotorLeadGeneration = React.lazy(() => import("./application/motor/pages/leadGen/leadGen"));
const MotorLeadPolicy = React.lazy(() => import("./application/motor/pages/LeadPolicyDetails/index"));
const MotorPersonalDetails = React.lazy(() => import("./application/motor/pages/PersonalDetails/index"));
const MotorPolicyDetails = React.lazy(() => import("./application/motor/pages/PolicyDetails/index"));
const MotorVehicleDetails = React.lazy(() => import("./application/motor/pages/VehicleDetails/index"));
const MotorTawuniyaLead = React.lazy(() => import("./application/motor/pages/TawnLead/TawnLead"));
const LeadPolicyDetails = React.lazy(() => import("./application/motor/pages/LeadPolicyDetails/index"));

const routes = [
//-----------------------------------------------------------------------------
// MOTOR -Start-
  {
    name: "motorPersonalDetails",
    idx: "motorPersonalDetails",
    route: "/",
    component: <MotorWrapper component={MotorPersonalDetails} />,
  },
  {
    name: "motor-vehicle-detail",
    idx: "motor-vehicle-detail",
    route: "/vehicle-details",
    component: <MotorWrapper component={MotorVehicleDetails} />,
  },

  {
    name: "motor-policy-detail",
    idx: "motor-policy-detail",
    route: "/policy-details",
    component: <MotorWrapper component={MotorPolicyDetails} />,
  },
  {
    name: "motorKycFail",
    idx: "motorKycFail",
    route: "/kyc-fail",
    component: <KycFailMotor />,
  },

  {
    name: "motor-lead",
    key: "motor-lead",
    route: "/twLead",
    component: <MotorTawuniyaLead />,
  },

  {
    name: "motor-lead",
    key: "motor-lead",
    route: "/lead",
    component: <MotorLeadGeneration />,
  },

    {
    name: "motor-lead-vehicle-details",
    key: "motor-lead-vehicle-details",
    route: "/lead/vehicle-details",
    component: <MotorLeadPolicy />,
  },

  {
    name: "motor-lead",
    key: "motor-lead",
    route: "/lead/policy-details",
    component: <LeadPolicyDetails />,
  },

// MOTOR -End-
//-----------------------------------------------------------------------------


//-----------------------------------------------------------------------------
//MOTOR business line routes -Start-
  {
    name: "motorPersonalDetails",
    idx: "motorPersonalDetails",
    route: ":businessLine",
    component: <MotorWrapper component={MotorPersonalDetails} />,
  },
  {
    name: "motor-vehicle-detail",
    idx: "motor-vehicle-detail",
    route: ":businessLine/vehicle-details",
    component: <MotorWrapper component={MotorVehicleDetails} />,
  },

  {
    name: "motor-policy-detail",
    idx: "motor-policy-detail",
    route: ":businessLine/policy-details",
    component: <MotorWrapper component={MotorPolicyDetails} />,
  },
  {
    name: "motor-lead",
    key: "motor-lead",
    route: ":businessLine/lead",
    component: <MotorLeadGeneration />,
  },
  {
    name: "motorKycFail",
    idx: "motorKycFail",
    route: ":businessLine/kyc-fail",
    component: <KycFailMotor />,
  },
  
//MOTOR business line routes -End-
//-----------------------------------------------------------------------------

];

export default routes;
